import {ReviewEntry} from "src/app/model/ReviewEntry";

export const MOCK_REVIEW_LIST: ReviewEntry[] = [
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2809",
        reviewStatus: "PENDING",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2808",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2807",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2806",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2805",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2804",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a280Y",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a280X",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2809",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2808",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2807",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2806",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2805",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2804",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a280Y",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a280X",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "KKK",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2809",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "BBB",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2808",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "CCC",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2807",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "DDD",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2806",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "FFF",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2805",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2804",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a280Y",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a280X",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2809",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2808",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2807",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2806",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2805",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2804",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a280Y",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a280X",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2809",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2808",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2807",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2806",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2805",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a2804",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a280Y",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    },
    {
        caseType: "BWND",
        creationDate: "2024-05-17T16:18:04.984753373Z",
        reviewResult: "PENDING",
        caseSubType: "BWND",
        referenceId: "A1GQ9DN6E5FYYO",
        referenceSubType: "DP",
        referenceType: "Transporter",
        reviewId: "f811f0fc-8c10-489e-9b02-4d3e6c7a280X",
        reviewStatus: "PENDING",
        reviewType: "DEFAULT",
        country: "US",
        providerId: "provider_id"
    }
]